import React, { useEffect, useState } from 'react';
import { Button, Input } from '../../components/common';
import { settingService } from '../../services/resources';
import { apiError } from '../../services/api';
import { useAuth } from '../../context/AuthContext';

export default function GeneralTab({ onToast }) {
  const { can } = useAuth();
  const canEdit = can('SETTINGS', 'CanEdit');
  const [form, setForm] = useState({ StoreName: '', Address: '', Address2: '', Phone: '' });
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    settingService
      .get()
      .then((d) =>
        setForm({
          StoreName: d.StoreName || '',
          Address: d.Address || '',
          Address2: d.Address2 || '',
          Phone: d.Phone || '',
        })
      )
      .catch((err) => onToast?.(apiError(err).message, 'error'))
      .finally(() => setLoading(false));
    // eslint-disable-line
  }, []); // eslint-disable-line

  const set = (k, v) => setForm((p) => ({ ...p, [k]: v }));

  const save = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      await settingService.save(form);
      onToast?.('Settings saved');
    } catch (err) {
      onToast?.(apiError(err).message, 'error');
    } finally {
      setSaving(false);
    }
  };

  if (loading) return <p className="text-sm text-gray-400">Loading…</p>;

  return (
    <form onSubmit={save} className="max-w-lg space-y-4">
      <Input label="Store Name" value={form.StoreName} disabled={!canEdit} onChange={(e) => set('StoreName', e.target.value)} />
      <Input label="Address" value={form.Address} disabled={!canEdit} onChange={(e) => set('Address', e.target.value)} />
      <Input label="Address 2" value={form.Address2} disabled={!canEdit} onChange={(e) => set('Address2', e.target.value)} />
      <Input label="Phone" value={form.Phone} disabled={!canEdit} onChange={(e) => set('Phone', e.target.value)} />
      {canEdit && (
        <Button type="submit" disabled={saving}>
          {saving ? 'Saving…' : 'Save changes'}
        </Button>
      )}
    </form>
  );
}
